import "slick-carousel/slick/slick";

jQuery(document).ready(function () {

    var slidesToShowXXL;
    var slidesToShowLG;

    if(jQuery(".social-dm-media-slider").attr("data-items") <= 5){
        slidesToShowXXL = 3;
    } else {
        slidesToShowXXL = 5;
    }
    
    if (jQuery(".social-dm-media-slider").attr("data-items") <= 3){
        slidesToShowLG = 1;
    } else {
        slidesToShowLG = 3;
    }

    jQuery(".social-dm-media-slider").on('init', function(event, slick){
        if(jQuery(".social-dm-media-slider .slick-slide:not(.slick-cloned)").length <= 1){
            jQuery(".social-dm-media-sec .slick-arrow").addClass("hidden");
        }
    });

    jQuery(".social-dm-media-slider").slick({
        mobileFirst: true,
        slidesToShow: 1,
        centerMode: true,
        arrows: false,
        prevArrow: jQuery(".social__prev"),
        nextArrow: jQuery(".social__next"),
        dots: true,
        focusOnSelect: false,
        centerPadding: "17%",
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    centerMode: false,
                    slidesToShow: slidesToShowLG,
                    centerPadding: "0",
                    arrows: true
                }
            },
            {
                breakpoint: 1399,
                settings: {
                    centerMode: false,
                    slidesToShow: slidesToShowXXL,
                    centerPadding: "0",
                    arrows: true,
                }
            }
        ],
    });
});
